import { DropFileArea } from '@/components/dueDiligence-page/dueDiligenceRecord/dropFileArea';
import { themeVar } from '@/styles/theme';
import { Dispatch, SetStateAction } from 'react';
import styled from 'styled-components';
import Select from '../basicComponents/select';
import { createSimpleSelectOption } from '../basicComponents/select/utils';

interface AiPaneZeroStateProps {
  useUnstructured: boolean;
  selectedProcessingOption: string;
  fileExtensions: string[];
  setSelectedProcessingOption: Dispatch<SetStateAction<string>>;
  handleUploadFile: (e: React.ChangeEvent<HTMLInputElement>, selectedProcessingOption?: string) => void;
  onDropHandler: (e: React.DragEvent<HTMLDivElement>, selectedProcessingOption?: string) => void;
  drag: boolean;
  setDrag: Dispatch<SetStateAction<boolean>>;
}

const processingOptions = ['Text only', 'Text with enhanced table processing', 'Full OCR (required for all image documents)'].map((option) =>
  createSimpleSelectOption(option)
);

export const AiPaneZeroState = ({
  useUnstructured,
  selectedProcessingOption,
  fileExtensions,
  setSelectedProcessingOption,
  handleUploadFile,
  onDropHandler,
  drag,
  setDrag
}: AiPaneZeroStateProps) => {
  return (
    <AiPaneBodyWrapper>
      <UploadText>Please upload source docs before using the AI Assistant.</UploadText>
      {useUnstructured && (
        <Select
          value={selectedProcessingOption}
          setValue={setSelectedProcessingOption}
          options={processingOptions}
          label="Select a document processing option:"
          size="sm"
        />
      )}
      {!!selectedProcessingOption && (
        <DropFileArea
          id={'handle-upload-file'}
          selectedProcessingOption={selectedProcessingOption}
          handleUploadFile={handleUploadFile}
          onDropHandler={onDropHandler}
          drag={drag}
          setDrag={setDrag}
          fileExtensions={fileExtensions}
          withIcon
        />
      )}
    </AiPaneBodyWrapper>
  );
};

const AiPaneBodyWrapper = styled.div`
  padding-top: 40px;
`;

const UploadText = styled.p`
  font-weight: 400;
  font-size: 16px;
  color: ${themeVar('font.base')};
  padding-left: 20px;
  margin-bottom: 30px;
`;
